import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ErrorLogger from 'Components/ErrorLogger'
import GlobalComponent from 'Components/GlobalComponent'
import Sidebar from 'Components/Sidebar'
import Topbar from 'Components/Topbar'
import requireAuth from 'HigherOrderComponents/RequireAuth'

import * as styles from './styles'

class MainLayout extends Component {
  componentDidCatch(error, info) {
    console.log({ error, info }) // eslint-disable-line no-console
  }

  render() {
    return (
      <ErrorLogger>
        <GlobalComponent />

        <div>
          <Sidebar />

          <Topbar />

          <div style={styles.content}>{this.props.children}</div>
        </div>
      </ErrorLogger>
    )
  }
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default requireAuth(MainLayout)
